import { ACCOUNT_FEATURE, selectUserRolePermissions } from '@socialive/common';
import { useFeature } from '@socialive/features';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

export default function NavMenu() {
  const { pathname: location } = useLocation();
  const { canNavigateInPortal, canViewOwnRecordings } = useSelector(selectUserRolePermissions);
  const [, { enabled: isRolesFeatureEnabled }] = useFeature(ACCOUNT_FEATURE.USER_ROLES);

  if (canNavigateInPortal) {
    return (
      <ul className="header-nav">
        <li className="nav-link">
          <Link to="/dashboard" className={location === '/dashboard' ? 'active' : ''}>
            My broadcasts
          </Link>
        </li>

        <li className="nav-link">
          <Link to="/join" className={location.includes('/join') ? 'active' : ''}>
            Join a broadcast
          </Link>
        </li>

        <li className="nav-link">
          <Link
            to="/recordings"
            className={classNames({
              active: location.includes('/recordings') || location.includes('/broadcastdetails'),
            })}
          >
            Recordings
          </Link>
        </li>
      </ul>
    );
  }

  if (isRolesFeatureEnabled && !canNavigateInPortal && canViewOwnRecordings) {
    return (
      <ul className="header-nav">
        <li className="nav-link">
          <Link to="/dashboard" className={location === '/dashboard' ? 'active' : ''}>
            Join a broadcast
          </Link>
        </li>

        <li className="nav-link">
          <Link
            to="/recordings"
            className={classNames({
              active: location.includes('/recordings') || location.includes('/broadcastdetails'),
            })}
          >
            Recordings
          </Link>
        </li>
      </ul>
    );
  }

  return null;
}
